import Loadable from 'react-loadable'
import LoadingComponent from 'components/common/loading-component'
const LoadableImporter: any = Loadable({
  // @ts-ignore
  loader: () => import('pages/contacts/import/importer'),
  loading: LoadingComponent,
})
export default LoadableImporter
